export const CHANGE_TRENDING_PRODUCT_FIELD = 'CHANGE_TRENDING_PRODUCT_FIELD';
export const GET_SETTING_TRENDING_PRODUCT = 'GET_SETTING_TRENDING_PRODUCT';
export const GET_SETTING_TRENDING_PRODUCT_RESULT = 'GET_SETTING_TRENDING_PRODUCT_RESULT';
export const SAVE_SETTING_TRENDING_PRODUCT = 'SAVE_SETTING_TRENDING_PRODUCT';
export const SAVE_SETTING_TRENDING_PRODUCT_RESULT = 'SAVE_SETTING_TRENDING_PRODUCT_RESULT';
export const CLEAR_DATA_TRENDING_PRODUCT = 'CLEAR_DATA_TRENDING_PRODUCT';
export const CHANGE_TRENDING_PRODUCT_THEME = 'CHANGE_TRENDING_PRODUCT_THEME';
export const CHANGE_TRENDING_PRODUCT_SETTINGS = 'CHANGE_TRENDING_PRODUCT_SETTINGS';
